import { Component, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import * as lodash from 'lodash'
import { DroppedSignFieldData, TemplateFieldsEditorComponent } from '../fields-editor/template-fields-editor.component'
import { defaultFieldFont, defaultFieldFontSize, getColorByIndex, RoleColor } from '../fields/constants'
import { ContractTemplate, DragDropManagerService } from '@tokeet-frontend/signature'
import { SignFieldDef } from '@tokeet-frontend/signature'
import { TemplateTypes } from '@tokeet-frontend/signature'

export function createPlaceFieldsForm(fb: FormBuilder) {
  return fb.group({
    font: [defaultFieldFont.id],
    font_size: [defaultFieldFontSize],
    fields: [[]],
  })
}

export function setPlaceFieldsFormData(form: FormGroup, template: ContractTemplate) {
  form.patchValue({
    fields: template.fields,
    font: template.font || defaultFieldFont.id,
    font_size: template.font_size || defaultFieldFontSize,
  })
}

@Component({
  selector: 'app-place-fields-form',
  templateUrl: './place-fields-form.component.html',
  styleUrls: ['./place-fields-form.component.scss'],
})
export class PlaceFieldsFormComponent implements OnInit, OnDestroy {
  @Input() templateType: TemplateTypes
  @Input() templateFileUrl: string
  @Input() roles: string[]
  @Input() form: FormGroup
  @Input() showStep: boolean
  @Input() isOnetime: boolean

  @HostBinding('class.open')
  isSelectorSidebarOpen = true

  defaultFieldElm: HTMLElement
  defaultSignFieldData: DroppedSignFieldData

  get font() {
    return this.form && this.form.get('font').value
  }

  get fontSize() {
    return this.form && this.form.get('font_size').value
  }

  get fields(): SignFieldDef[] {
    return this.form && this.form.get('fields').value
  }

  @ViewChild('editor') editor: TemplateFieldsEditorComponent

  roleColors: RoleColor[]
  currentRole: string
  constructor(private signFieldManager: DragDropManagerService) {
    this.signFieldManager.setup('draggable-sign-field-element', (el: HTMLElement) =>
      this.getSignFieldDataFromElement(el)
    )
  }

  ngOnInit(): void {
    this.roleColors = lodash.map(this.roles, (role, i) => ({
      role,
      color: getColorByIndex(i),
    }))
  }

  ngOnDestroy() {
    const fields = this.getFieldsConfig()
    this.form.patchValue({ fields })
  }

  onToggleSidebar() {
    this.isSelectorSidebarOpen = !this.isSelectorSidebarOpen
  }

  isTemplateReady() {
    return this.editor.isTemplateReady()
  }

  getFieldsConfig() {
    return this.editor.getFieldsConfig()
  }

  getSignFieldDataFromElement(el: HTMLElement): DroppedSignFieldData {
    const type = lodash.get(el, 'dataset.type')
    const label = lodash.get(el, 'dataset.label')
    const key = lodash.get(el, 'dataset.key')
    const field = lodash.get(el, 'dataset.field')
    const dataType = lodash.get(el, 'dataset.dataType')
    const prefillType = lodash.get(el, 'dataset.prefillType')

    return {
      type,
      label,
      attributes: { key, data_type: dataType, field, prefill_type: prefillType },
    }
  }

  onSelectedSignFieldChange(elm: HTMLElement) {
    if (elm === this.defaultFieldElm) {
      this.defaultSignFieldData = null
      this.defaultFieldElm = null
    } else {
      this.defaultSignFieldData = elm ? this.getSignFieldDataFromElement(elm) : null
      this.defaultFieldElm = elm
    }
  }
}
